import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

export const SubmissionFeedbackSkeleton: FC = () => (
  <Box sx={{ borderRadius: '10px', bgcolor: '#fff5f7', px: 2.5, py: 2 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2 }}>
      <Skeleton variant="circular" width={32} height={32} />
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width={200} />
        <Skeleton variant="text" width={110} />
      </Box>
    </Box>
    <Skeleton variant="text" width={160} />
    <Skeleton variant="text" />
    <Skeleton variant="text" width="80%" />
  </Box>
);
